/* Carrossel de posts do Instagram (section instagram-carrossel.liquid).
   Arquivo do tema, carregado com defer e reaproveitado em todas as paginas.
   Cada instancia se configura pelos data- da propria secao. */
(function () {
  function iniciar(faixa) {
    if (faixa.dataset.pronto) return;
    faixa.dataset.pronto = '1';

    var id = faixa.dataset.id;
    var trilho = faixa.querySelector('.ig-trilho');
    var fita = faixa.querySelector('.ig-fita');
    var lupa = document.getElementById('ig-lupa-' + id);
    var cru = document.getElementById('ig-dados-' + id);
    if (!trilho || !fita || !lupa) return;

    // O lightbox sai da secao e vai para o <body>. Dentro da secao ele nao funciona:
    // base.css da `content-visibility: auto` as secoes abaixo da dobra, e um ancestral com
    // `contain` faz o position:fixed valer contra a secao, nao contra a tela — o post abria
    // cortado e sem rolagem. Fora da secao nenhuma regra do tema o alcanca.
    if (lupa.parentElement !== document.body) document.body.appendChild(lupa);

    var palco = lupa.querySelector('.ig-lupa__slides');
    var pontos = lupa.querySelector('.ig-lupa__pontos');
    var ant = lupa.querySelector('.ig-lupa__nav--ant');
    var prox = lupa.querySelector('.ig-lupa__nav--prox');
    var texto = lupa.querySelector('.ig-lupa__texto');
    var verNoInsta = lupa.querySelector('.ig-lupa__ver');
    var atual = 0, total = 0;

    /* ---------- movimento continuo ---------- */
    var VOLTA_S = Number(faixa.dataset.volta) || 70;        // segundos para uma volta
    var ESPERA_MS = (Number(faixa.dataset.espera) || 3) * 1000;  // parado depois que o cliente mexe
    var paradoAte = 0, arrastando = false, ultimo = 0, pos = 0, quadro = 0, clonado = false, naTela = false;
    var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function adiar() { paradoAte = Date.now() + ESPERA_MS; }
    // Passar o mouse por cima NAO conta como acao: o passeio so para quando o cliente
    // realmente conduz (arrasta, roda, teclado) e volta sozinho quando ele para.
    function noComando() { return arrastando || !lupa.hidden || Date.now() < paradoAte; }

    function passo(agora) {
      quadro = requestAnimationFrame(passo);
      var dt = ultimo ? agora - ultimo : 16;
      ultimo = agora;
      // enquanto o cliente manda, a posicao vem do scroll dele; depois o passeio continua
      // de onde ele parou, sem salto
      if (reduzido || noComando()) { pos = trilho.scrollLeft; return; }
      var metade = fita.scrollWidth / 2;
      if (!metade) return;
      pos += (metade / (VOLTA_S * 1000)) * Math.min(dt, 50);
      if (pos >= metade) pos -= metade;
      trilho.scrollLeft = pos;
    }

    /* O passeio so existe quando o carrossel esta perto da tela: durante o carregamento da
       pagina o custo e zero. A segunda volta de cartoes tambem so e clonada ai — no HTML
       vai uma passada so. */
    function clonar() {
      if (clonado) return;
      clonado = true;
      var copia = fita.cloneNode(true);
      while (copia.firstElementChild) {
        var n = copia.firstElementChild;
        n.setAttribute('aria-hidden', 'true');
        n.tabIndex = -1;
        fita.appendChild(n);
      }
    }
    function liga() { if (quadro) return; ultimo = 0; quadro = requestAnimationFrame(passo); }
    function desliga() { if (quadro) cancelAnimationFrame(quadro); quadro = 0; }

    new IntersectionObserver(function (entradas) {
      naTela = entradas[0].isIntersecting;
      if (naTela) { clonar(); liga(); } else { desliga(); }
    }, { rootMargin: '250px 0px' }).observe(trilho);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) desliga(); else if (naTela) liga();
    });

    // arrastando para tras, ao chegar no comeco salta para a copia e segue infinito
    trilho.addEventListener('scroll', function () {
      var metade = fita.scrollWidth / 2;
      if (metade && noComando() && trilho.scrollLeft < 1) trilho.scrollLeft += metade;
    }, { passive: true });

    // qualquer acao do cliente pausa; depois de ESPERA_MS parado, o movimento volta sozinho
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      trilho.addEventListener(ev, adiar, { passive: true });
    });
    trilho.addEventListener('touchmove', adiar, { passive: true });

    /* no celular o dedo ja arrasta sozinho (o trilho rola de verdade); no computador o
       mesmo gesto e feito com o mouse apertado */
    var xInicial = 0, scrollInicial = 0, puxou = false;
    trilho.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrastando = true; puxou = false;
      xInicial = e.clientX; scrollInicial = trilho.scrollLeft;
    });
    trilho.addEventListener('pointermove', function (e) {
      if (!arrastando) return;
      var d = e.clientX - xInicial;
      if (!puxou && Math.abs(d) > 4) { puxou = true; trilho.classList.add('ig-puxando'); trilho.setPointerCapture(e.pointerId); }
      if (!puxou) return;
      trilho.scrollLeft = scrollInicial - d;
      e.preventDefault();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      trilho.addEventListener(ev, function () {
        if (!arrastando) return;
        arrastando = false;
        trilho.classList.remove('ig-puxando');
        adiar();
        // solta o travao do clique so depois do evento de clique deste mesmo gesto
        setTimeout(function () { puxou = false; }, 0);
      });
    });

    /* ---------- post aberto ---------- */
    function comLargura(url, l) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + l; }

    // o bloco de dados so e lido na primeira vez que um post e aberto
    var dados = null;
    function post(i) {
      if (!dados) { try { dados = JSON.parse(cru.textContent); } catch (e) { dados = []; } }
      return dados[i];
    }

    function mostra(i) {
      var slides = palco.children;
      if (!slides.length) return;
      atual = (i + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) {
        var ativo = k === atual;
        slides[k].classList.toggle('ativo', ativo);
        if (slides[k].tagName === 'VIDEO' && !ativo) slides[k].pause();
        if (pontos.children[k]) pontos.children[k].classList.toggle('ativo', ativo);
      }
      // adianta os vizinhos: assim o proximo slide ja esta pronto quando ele avancar
      [atual + 1, atual - 1].forEach(function (k) {
        var el = slides[(k + slides.length) % slides.length];
        if (el && el.tagName === 'IMG' && !el.dataset.pronta) {
          el.dataset.pronta = '1';
          var aquece = new Image();
          aquece.src = el.src;
        }
      });
    }

    function abrir(botao) {
      var d = post(Number(botao.dataset.i));
      if (!d) return;
      var midias = d.m || [];
      palco.innerHTML = '';
      pontos.innerHTML = '';
      midias.forEach(function (m) {
        var el;
        if (m.tipo === 'video') {
          el = document.createElement('video');
          el.src = m.url;
          if (m.poster) el.poster = comLargura(m.poster, 900);
          el.controls = true;
          el.playsInline = true;
          el.preload = 'none';   // so baixa quando o cliente der play
        } else {
          el = document.createElement('img');
          el.src = comLargura(m.url, 900);
          el.alt = '';
          el.decoding = 'async';
        }
        el.className = 'ig-lupa__slide';
        palco.appendChild(el);
        pontos.appendChild(document.createElement('span'));
      });
      total = midias.length;
      var varios = total > 1;
      ant.hidden = !varios; prox.hidden = !varios; pontos.hidden = !varios;
      texto.textContent = d.c || '';
      verNoInsta.href = d.l;
      mostra(0);
      lupa.hidden = false;
      document.body.style.overflow = 'hidden';
      lupa.querySelector('.ig-lupa__fechar').focus();
    }

    function fechar() {
      palco.querySelectorAll('video').forEach(function (v) { v.pause(); });
      lupa.hidden = true;
      palco.innerHTML = '';
      document.body.style.overflow = '';
      // devolver o foco ao cartao deixava o trilho em :focus-within e a fita parada;
      // por isso o foco nao volta e o movimento recomeca depois da espera.
      adiar();
    }

    trilho.addEventListener('click', function (e) {
      if (puxou) return;   // arrastou para ver os posts, nao quis abrir
      var botao = e.target.closest('.ig-post');
      if (botao) abrir(botao);
    });
    ant.addEventListener('click', function () { mostra(atual - 1); });
    prox.addEventListener('click', function () { mostra(atual + 1); });
    lupa.addEventListener('click', function (e) {
      if (e.target === lupa || e.target.closest('.ig-lupa__fechar')) fechar();
    });
    document.addEventListener('keydown', function (e) {
      if (lupa.hidden) return;
      if (e.key === 'Escape') fechar();
      if (e.key === 'ArrowLeft' && total > 1) mostra(atual - 1);
      if (e.key === 'ArrowRight' && total > 1) mostra(atual + 1);
    });
    var x0 = null;
    palco.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    palco.addEventListener('touchend', function (e) {
      if (x0 === null || total < 2) return;
      var d = e.changedTouches[0].clientX - x0;
      if (Math.abs(d) > 40) mostra(atual + (d < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    // no editor de temas a secao e recarregada: leva junto o lightbox que foi para o body
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId === id) lupa.remove();
    });
  }

  function varrer(raiz) {
    (raiz || document).querySelectorAll('.ig-faixa').forEach(iniciar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { varrer(); });
  else varrer();
  document.addEventListener('shopify:section:load', function (e) { varrer(e.target); });
})();
